<template>
  <div class="c-contact-us-wrapper">
    <div class="banner">
      <img :src="banner" alt="" />
    </div>
    <div class="container">
      <div class="tab">
        <div class="tab-item">
          <div class="tab-item-front">
            <i class="iconfont icon-zhifeiji"></i>
            <span>{{ $t("title.contactUs") }}</span>
          </div>
          <div class="tab-item-back">
            <dd>
              <i class="iconfont icon-dianhua"></i>
              <span>{{ $store.state.contactUsData.FPhone }}</span>
            </dd>
            <dd>
              <i class="iconfont icon-duanxinqunfa"></i>
              <span>{{ $store.state.contactUsData.Email }}</span>
            </dd>
            <dd>
              <i class="iconfont icon-ditu_dingwei"></i>
              <span>{{ formatAdress($store.state.contactUsData) }}</span>
            </dd>
          </div>
        </div>
        <div class="tab-item">
          <div class="tab-item-front">
            <i class="iconfont icon-erweima"></i>
            <span>{{ $t("title.aboutUs") }}</span>
          </div>
          <div class="tab-item-back qr-code-wrap">
            <div class="img-wrap">
              <i>Alibaba</i>
              <img
                class="qr-code"
                :src="$store.state.contactUsData.WebSite"
                alt=""
              />
            </div>
            <div class="img-wrap">
              <i>Wechat</i>
              <img class="qr-code" :src="erweima2" alt="" />
            </div>
          </div>
        </div>
      </div>

      <div class="map" style="width: 1200px;height: 635px;" id="map">
        <el-amap class="amap-box" vid="map" :zoom="zoom" :center="center">
          <el-amap-marker vid="marker" :position="center"></el-amap-marker>
          <el-amap-text
            text="温州智亚工贸有限公司"
            :offset="[0, 0]"
            :position="center"
          ></el-amap-text>
          <el-amap-circle
            vid="circle"
            :center="center"
            :radius="radius"
            fill-opacity="0.2"
            strokeColor="#38f"
            strokeOpacity="0.8"
            strokeWeight="1"
            fillColor="#38f"
          >
          </el-amap-circle>
        </el-amap>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      banner: "",
      showContactUs: false,
      showQRCode: false,
      zoom: 18,
      center: [120.695315, 27.767961],
      radius: 100,
      erweima2: ""
    };
  },
  plugin: ["ToolBar", "PolyEditor"],
  mounted() {
    const params = {
      Data: {
        FInterID: 6
      }
    };
    this.$store.dispatch("getIndexBodyData", params).then(res => {
      this.banner = res.Data.WebSite;
    });

    // 后期新增了一张二维码
    const params2 = {
      Data: {
        FInterID: 9
      }
    };
    this.$store.dispatch("getIndexBodyData", params2).then(res => {
      this.erweima2 = res.Data.WebSite;
    });
  },
  methods: {
    formatAdress(item) {
      let adress;
      if (this.$i18n.locale === "zh") {
        adress = item.Adress;
      } else if (this.$i18n.locale === "en") {
        adress = item.EnglishAdress;
      } else if (this.$i18n.locale === "sp") {
        adress = item.xibanyaAdress;
      }
      return adress;
    }
  }
};
</script>

<style lang="less">
@import "~@/assets/style/variables.less";
.c-contact-us-wrapper {
  .banner {
    width: 100%;
    height: 560px;
    // background: pink;

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .container {
    width: 1200px;
    margin: 0 auto;
    padding: 0 0 60px;

    .tab {
      display: flex;
      margin-bottom: 60px;
      transform: translateY(-40px);

      .tab-item {
        flex: 1;
        height: 200px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.05);
        cursor: pointer;
        position: relative;
        perspective: 500;
        -webkit-perspective: 500;

        .tab-item-front,
        .tab-item-back {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          // background-color: #fff;
          -webkit-perspective: 1000;
          /*backface-visibility: hidden;*/
          -webkit-transition: all 1.5s;
          -moz-transition: all 1.5s;
          -ms-transition: all 1.5s;
          -o-transition: all 1.5s;
          box-shadow: rgba(50, 50, 50, 0.2) 0 0 15px;
          overflow: hidden;
        }

        .tab-item-front {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;

          i {
            font-size: 48px;
            color: #dcdcdc;
            margin-bottom: 36px;
          }

          span {
            font-size: 46px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(220, 220, 220, 1);
          }
        }

        .tab-item-back {
          position: relative;
          transform: rotateY(-180deg);
          -webkit-transform: rotateY(-180deg);

          dd {
            display: none;
          }

          .img-wrap {
            display: none;
          }
        }
      }

      .tab-item:first-child {
        margin-right: 10px;
      }

      .tab-item:hover {
        .tab-item-front {
          transform: rotateY(-180deg);
          -webkit-transform: rotateY(-180deg);
        }

        .tab-item-back {
          transform: rotateY(-360deg);
          -webkit-transform: rotateY(-360deg);
          text-align: left;
          background: @bgColor;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          dd {
            width: 80%;
            flex: 1;
            display: flex;
            align-items: center;
            color: #fff;

            .iconfont {
              font-size: 36px;
              margin-right: 13px;
            }

            span {
              flex: 1;
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 21px;
            }
          }
        }

        .qr-code-wrap {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          flex-direction: row;

          .img-wrap {
            display: block;

            i {
              display: block;
              width: 131px;
              margin-bottom: 16px;
              position: relative;
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #ffffff;
              padding-left: 40px;
            }

            i::before {
              content: "";
              display: block;
              width: 36px;
              height: 36px;
              background: url("../../../../assets/imgs/wechat.png") top center
                no-repeat;
              background-size: 100% 100%;
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
            }

            .qr-code {
              display: block;
              width: 131px;
              height: 131px;
            }
          }

          .img-wrap:first-child {
            margin-right: 30px;

            i::before {
              content: "";
              display: block;
              width: 36px;
              height: 36px;
              background: url("../../../../assets/imgs/alibaba.png") top center
                no-repeat;
              background-size: 100% 100%;
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
            }
          }
        }
      }
    }
  }
}
</style>
